module.exports = __webpack_public_path__ + "img/test.6472b73c.jpg";